import { GoalGroupsList } from "@components/consumer/goalGroups";
import withPage from "@components/hoc/withPage";
import { FC } from "react";

const GoalGroupsListPage: FC = () => {
    return <GoalGroupsList />
}

export default withPage(GoalGroupsListPage);
